import {
  Button,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  Input,
  InputGroup,
  InputRightElement,
  HStack,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import {
  FaEnvelope,
  FaFacebook,
  FaFacebookMessenger,
  FaTwitter,
} from "react-icons/fa";
import {
  FacebookShareButton,
  FacebookMessengerShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";

interface IShareData {
  name: string;
  url: string;
  isOpen: boolean;
  image?: string;
  onClose: () => void;
}
function ShareProfileModal(props: IShareData) {
  const [copy, setCopy] = React.useState(false);
  const urlRef = useRef<HTMLInputElement>(null);

  const handleClick = (e: any) => {
    setCopy(!copy);
    urlRef?.current?.select();
    document.execCommand("copy");
    e.target.focus();
    props.onClose();
    setCopy(copy);
  };
  return (
    <>
      <Modal
        blockScrollOnMount={true}
        isOpen={props.isOpen}
        onClose={props.onClose}
        isCentered
        colorScheme="red"
        motionPreset="slideInBottom"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent background="whitesmoke">
          <ModalHeader>Share the Profile of {props.name}</ModalHeader>
          <ModalCloseButton
            _focus={{
              outline: "none",
              boxShadow: "none",
              textDecor: "none",
            }}
          />
          <ModalBody>
            <HStack marginBottom="5" justify="center">
              <FacebookShareButton
                url={props.url}
                quote={
                  "View the detail profile of the political stakeholders around the world."
                }
              >
                <FaFacebook
                  title="Facebook"
                  style={{
                    width: "30",
                    height: "30",
                  }}
                  color="#4267B2"
                />
              </FacebookShareButton>
              <FacebookMessengerShareButton
                url={props.url}
                quote={
                  "View the detail profile of the political stakeholders around the world."
                }
              >
                <FaFacebookMessenger
                  title="Messenger"
                  style={{
                    width: "30",
                    height: "30",
                  }}
                  color="#006AFF"
                />
              </FacebookMessengerShareButton>
              <TwitterShareButton
                url={props.url}
                quote={
                  "View the detail profile of the political stakeholders around the world."
                }
              >
                <FaTwitter
                  title="Twitter"
                  color="#1DA1F2"
                  style={{
                    width: "30",
                    height: "30",
                  }}
                />
              </TwitterShareButton>

              <EmailShareButton
                subject={
                  "View the detail profile of the political stakeholders around the world."
                }
                body={`
                <!DOCTYPE html >
                <body>
                <a href= ${props.url}> Go to this</ a>
                <img src=${props.image}/>
                </ body>
                </ html>
                `}
                separator={""}
              >
                <FaEnvelope
                  title="Email"
                  style={{
                    width: "30",
                    height: "30",
                  }}
                />
              </EmailShareButton>
            </HStack>

            <InputGroup size="sm" background="white">
              <Input
                pr="4.5rem"
                type="text"
                value={props.url}
                readOnly
                ref={urlRef}
              />
              <InputRightElement width="4.5rem">
                <Button
                  textColor="white"
                  background="black"
                  h="1.75rem"
                  id="CopyLink"
                  size="sm"
                  onClick={handleClick}
                  _hover={{
                    textColor: "black",
                    background: "white",
                  }}
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                >
                  {copy ? "Copied" : "Copy"}
                </Button>
              </InputRightElement>
            </InputGroup>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
export default ShareProfileModal;
